export enum statusMessage {
  default = '',
  saving = 'Saving Changes...',
  success = 'All Changes have been saved.',
  error = 'Something went wrong!',
}
